import { FC } from "react";

import { getMetaCount } from "helpers/metaUtils";
import { IMeta } from "store/user/user.types";
import { CountBadge } from "components/common";

interface INavigationCountBadgeProps {
  meta: IMeta | null;
  sectionKey: string;
  metaKey?: string;
}

const NavigationCountBadge: FC<INavigationCountBadgeProps> = ({
  meta,
  sectionKey,
  metaKey,
}) => {
  if (!metaKey) return null;

  const count = getMetaCount(meta, sectionKey, metaKey);

  return (
    <CountBadge count={ count } />
  );
};

export default NavigationCountBadge;
